import axios from 'axios';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';

const config = {
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
  },
};

export function processHostname(hostnameProvided) {
  let host = hostnameProvided.replace(/\s+/g, '');

  host = host.replace(/\.test$/i, ''); // replace .test at the end of string
  host = host.replace(/^test\./i, ''); // replace test. at the start of string
  host = host.replace(/^beta\./i, ''); // replace beta. at the start of string for local white labels
  host = host.replace(/^www\./i, ''); // replace www. at the start of string

  return host.replace(/(\.[a-z]{2,3})*\.[a-z]{2,3}$/i, '');
}

export function get(url) {
  return axios.get(url, config);
}

export function post(url, body) {
  return axios.post(url, body, config);
}

export function getWithToken(url, token) {
  const configAuthorization = {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return axios.get(url, configAuthorization);
}

export function postWithToken(url, body, token) {
  const configAuthorization = {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return axios.post(url, body, configAuthorization);
}

export function putWithToken(url, body, token) {
  const configAuthorization = {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return axios.put(url, body, configAuthorization);
}

export function getHostname() {
  const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
  const host = canUseDOM ? (isClient ? window.location.hostname : '') : '';
  let hostname = processHostname(host);
  if (hostname.includes('localhost')) {
    hostname = 'www.mundigea.com.ar';
  }
  return hostname;
}

export function pathname() {
  return isClient ? window.location.pathname : '';
}

export function getParameterByName(name, url) {
  /* eslint-disable */
  if (!url) url = isClient ? window.location.href : '';
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function Url(dataUrl) {
  const UrlObj = URL || require('url').URL;
  return new UrlObj(dataUrl);
}

export function getLocationInfo() {
  if (typeof window === 'undefined') {
    return global.expressLocation;
  } else {
    return window.location;
  }
}
